// Campo configurável de um card (modelo da fila ou campos adicionais do suporte):
// mostra o valor e edita na própria linha. Sem importar "comum" (evita import circular).
import React, { useState } from "react";
import { IconButton, MenuItem, TextField, makeStyles } from "@material-ui/core";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";

const useStyles = makeStyles((theme) => ({
  linha: { display: "flex", gap: 8, padding: "5px 0", fontSize: 13, alignItems: "flex-start" },
  rotulo: { color: theme.palette.text.secondary, minWidth: 92, flex: "none" },
  valor: { wordBreak: "break-word", cursor: "pointer", flex: 1 },
  vazio: { color: theme.palette.warning.main, borderBottom: `1px dashed ${theme.palette.warning.main}`, cursor: "pointer" },
}));

const TIPO_INPUT = { numero: "number", data: "date", email: "email", telefone: "tel" };
const dataCurta = (iso) => {
  const [a, m, d] = String(iso).slice(0, 10).split("-");
  return d ? `${d}/${m}/${a}` : iso;
};

const CampoCard = ({ campo, valor, opcoes, bloqueado, onSalvar }) => {
  const c = useStyles();
  const [editando, setEditando] = useState(false);
  const [v, setV] = useState("");
  const abrir = () => { if (!bloqueado) { setV(valor || ""); setEditando(true); } };
  const salvar = async () => { await onSalvar(campo.id, v); setEditando(false); };
  const mostra = campo.tipo === "data" && valor ? dataCurta(valor) : valor;
  return (
    <div className={c.linha}>
      <span className={c.rotulo}>{campo.rotulo}{campo.obrigatorio ? " *" : ""}</span>
      {editando ? (
        <span style={{ flex: 1, display: "flex", alignItems: "center" }}>
          <TextField
            size="small" fullWidth autoFocus value={v} select={campo.tipo === "lista"}
            multiline={campo.tipo === "paragrafo"} type={TIPO_INPUT[campo.tipo]}
            InputLabelProps={campo.tipo === "data" ? { shrink: true } : undefined}
            onChange={(e) => setV(e.target.value)}
            onKeyDown={(e) => { if (e.key === "Enter" && campo.tipo !== "paragrafo") salvar(); if (e.key === "Escape") setEditando(false); }}
          >
            {campo.tipo === "lista" && [<MenuItem key="" value="">—</MenuItem>, ...(opcoes || []).map((o) => <MenuItem key={o} value={o}>{o}</MenuItem>)]}
          </TextField>
          <IconButton size="small" onClick={salvar}><CheckIcon fontSize="small" /></IconButton>
          <IconButton size="small" onClick={() => setEditando(false)}><CloseIcon fontSize="small" /></IconButton>
        </span>
      ) : mostra ? (
        <span className={c.valor} onClick={abrir} title={bloqueado ? "" : "Clique para editar"} style={{ whiteSpace: "pre-wrap" }}>{mostra}</span>
      ) : (
        <span onClick={abrir}><span className={c.vazio}>{bloqueado ? "—" : "a informar – clique para preencher"}</span></span>
      )}
    </div>
  );
};

export default CampoCard;
